import {
  FleetVehicleDriver,
  FleetVehicleDriverEditFormValues,
  FleetVehicleDriverRow,
} from "./types";

export const transformFleetVehicleDriverRow = (
  res: any
): FleetVehicleDriverRow => {
  return {
    id: res.id,
    contact: res.contact ?? null,
    userId: res.userId ?? null,
    name: res.name ?? null,
    driversLicenceNumber: res.driversLicenceNumber,
    driversLicenceExpiry: res.driversLicenceExpiry,
    identityCardNumber: res.identityCardNumber,
    identityCardExpiry: res.identityCardExpiry,
    passportNumber: res.passportNumber,
    passportExpiry: res.passportExpiry,
    vehicle: res.vehicle,
  };
};

export const transformFleetVehicleDriverOnCreate = (
  formValues: FleetVehicleDriverEditFormValues,
  vehicleId: string
): any => ({
  contactId: formValues.contactId,
  userId: formValues.userId,
  vehicleId: vehicleId,
  driversLicenceNumber: formValues.driversLicenceNumber,
  driversLicenceExpiry: formValues.driversLicenceExpiry,
  identityCardNumber: formValues.identityCardNumber,
  identityCardExpiry: formValues.identityCardExpiry,
  passportNumber: formValues.passportNumber,
  passportExpiry: formValues.passportExpiry,
  // Popis je konačno stanje isprave — backend miče ono čega u njemu nema.
  driversLicenceUploadIds: formValues.driversLicenceUploads.map((u) => u.id),
  identityCardUploadIds: formValues.identityCardUploads.map((u) => u.id),
  passportUploadIds: formValues.passportUploads.map((u) => u.id),
});

export const transformFleetVehicleDriverOnUpdate = (
  formValues: FleetVehicleDriverEditFormValues,
  vehicleId: string
): any => ({
  id: formValues.id,
  contactId: formValues.contactId,
  userId: formValues.userId,
  vehicleId: vehicleId,
  driversLicenceNumber: formValues.driversLicenceNumber,
  driversLicenceExpiry: formValues.driversLicenceExpiry,
  identityCardNumber: formValues.identityCardNumber,
  identityCardExpiry: formValues.identityCardExpiry,
  passportNumber: formValues.passportNumber,
  passportExpiry: formValues.passportExpiry,
  // Popis je konačno stanje isprave — backend miče ono čega u njemu nema.
  driversLicenceUploadIds: formValues.driversLicenceUploads.map((u) => u.id),
  identityCardUploadIds: formValues.identityCardUploads.map((u) => u.id),
  passportUploadIds: formValues.passportUploads.map((u) => u.id),
});

export const transformFleetVehicleDriver = (res: any): FleetVehicleDriver => {
  return {
    id: res.id,
    contactId: res.contact?.id ?? null,
    userId: res.userId ?? null,
    driversLicenceNumber: res.driversLicenceNumber,
    driversLicenceExpiry: res.driversLicenceExpiry,
    identityCardNumber: res.identityCardNumber,
    identityCardExpiry: res.identityCardExpiry,
    passportNumber: res.passportNumber,
    passportExpiry: res.passportExpiry,
    driversLicenceUploads: res.driversLicenceUploads ?? [],
    identityCardUploads: res.identityCardUploads ?? [],
    passportUploads: res.passportUploads ?? [],
  };
};
